import { usePWA } from '../../hooks/usePWA';
import './PWABlocker.css';

const PWABlocker = () => {
  const { isStandalone, isMobile } = usePWA();

  // If not mobile, or if mobile and standalone, don't show anything
  // We only block on mobile devices that are NOT in standalone mode
  if (!isMobile || isStandalone) return null;

  const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);

  return (
    <div className="pwa-blocker-overlay">
      <div className="pwa-blocker-content">
        <img src="/pwa-192x192.png" alt="App Logo" className="pwa-app-logo" />
        <h1>Chain Reaction</h1>
        <p className="pwa-subtitle">
          Per giocare su dispositivi mobile è necessario installare l'app.
        </p>

        <div className="pwa-instructions-container">
          {isIOS ? (
            <div className="pwa-instruction-step">
              <h2>📱 iPhone / Safari</h2>
              <ol>
                <li>
                  Tocca l'icona <strong>Condividi</strong> <span className="icon-ios-share"></span>{' '}
                  nella barra in basso.
                </li>
                <li>
                  Scorri in basso fino a <strong>"Visualizza altro"</strong> (se presente) e cerca
                  il tasto <strong>"+" Aggiungi alla schermata Home</strong>.
                </li>
                <li>
                  Tocca <strong>Aggiungi</strong> in alto a destra.
                </li>
              </ol>
              <div className="pwa-pointer-arrow">
                <div className="arrow-animation">↓</div>
              </div>
            </div>
          ) : (
            <div className="pwa-instruction-step">
              <h2>📱 Android / Chrome</h2>
              <ol>
                <li>
                  Tocca i <strong>tre puntini</strong> <span className="icon">⋮</span> in alto a
                  destra.
                </li>
                <li>
                  Seleziona <strong>Installa applicazione</strong> o{' '}
                  <strong>Aggiungi a schermata Home</strong>.
                </li>
                <li>Segui le istruzioni per completare l'installazione.</li>
              </ol>
            </div>
          )}
        </div>

        <div className="pwa-footer">
          <p>Una volta aggiunta alla Home, apri l'app per iniziare l'avventura!</p>
        </div>
      </div>
    </div>
  );
};

export default PWABlocker;
